import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase-config";
import { customerApiClient } from "../api/customerHttpClient";

export async function requestPermission() {
  try {
    if (typeof window !== "undefined" && "Notification" in window) {
      if (Notification.permission === "denied") {
        console.warn("Push notifications are blocked by the user.");
        return null;
      }
    }

    // Read at call time (not module load) so it reflects the current session.
    const userdata = JSON.parse(localStorage.getItem("userData") || "null");
    if (!userdata?.id) {
      // Not logged in yet — no user to register the token against.
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BGfbQT4pdHqMQcav0g1hc8_C_66iC7mqM8SFZzqN4zkryFARSjNmhf4LpTmJQpqnG_ShOWFuCGzGUla2EEZXL9Q", // ✅ your public VAPID key
    });
    if (!token) return null;

    const formdata = new FormData();
    formdata.append("user_id", userdata.id);
    formdata.append("fcm_token", token);
    formdata.append("platform", "website");

    const response = await customerApiClient.post(
      "/Api/UserAuth/updateFCMToken",
      formdata,
      { allowSelfIdentity: true },
    );

    if (response?.data?.status === true) {
      // console.log("✅ FCM token updated:", token);
    }

    return token;
  } catch (err) {
    if (err?.code === "messaging/permission-blocked" || err?.message?.includes("Notification permission")) {
      console.warn("Push notifications were completely blocked or dismissed.");
    } else {
      console.error("❌ Error getting token:", err);
    }
    return null;
  }
}

export function listenForMessages(callback) {
  onMessage(messaging, (payload) => {
if (callback) callback(payload);
  });
}
